const SLUG_LIKE_PATTERN = /^[a-z0-9]+(?:[-_][a-z0-9]+)+$/i;

const INTERNAL_DESCRIPTION_PATTERN =
  /\b(public\s*key|private\s*key|publickey|privatekey|absent|fixture|null|undefined|object reference|npe|webhook|endpoint|payload|sandbox|stub|mock|harden|e2e|pk absent|mp[-_]?pk)\b/i;

export function getPackageSummaryName(name?: string | null): string {
  const trimmed = name?.trim();
  if (!trimmed) return "Pacote";
  if (SLUG_LIKE_PATTERN.test(trimmed)) return "Pacote de cursos";
  return trimmed;
}

export function getPackageSummaryDescription(description?: string | null): string | null {
  const trimmed = description?.trim();
  if (!trimmed) return null;
  if (SLUG_LIKE_PATTERN.test(trimmed)) return null;
  if (INTERNAL_DESCRIPTION_PATTERN.test(trimmed)) return null;
  return trimmed;
}
